import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import axios from 'axios';
import { useHistory, useLocation, useParams } from 'react-router';
import { ItemResponse, SaveResponse } from 'helpers/interfaces';
import { TypeInfo } from 'helpers/enums';


interface IContext {
    isSaving: boolean

    isLoading: boolean,
    ticketType: TicketType
    saveTicketType: (ticket: TicketType) => Promise<void>
}

export let ticketTypeSchema = yup.object().shape({
    ticketTypeId: yup.string().default(''),
    name: yup.string().default('').required(),
    typeInfo: yup.string().default(TypeInfo.Delivery)
});

type TicketType = yup.InferType<typeof ticketTypeSchema>;

export let ticketTypeContext = React.createContext({} as IContext);

let { Provider } = ticketTypeContext;

let TicketTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();

    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    
    let isNew = location.pathname.includes("/addnew");

    let [isSaving, setSaving] = useState(false);
    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [ticketType,setTicketType] = useState(ticketTypeSchema.getDefault())



    useEffect(() => {
        if (isNew === false)
            getTicketType();

    }, [id, isNew])

    let getTicketType = async () => {
        try {
            let res = await axios.get<ItemResponse<TicketType>>('/api/TicketType/GetTicketType', { params: { id } });

            let { item } = res.data;
            setTicketType(item);
            setLoading(false);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    
    let saveTicketType = async (ticketType: TicketType) => {
        try {
            setSaving(true);
            let res = await axios.post<SaveResponse>('/api/TicketType/SaveTicketType', ticketType);
            history.goBack();
        } catch (err) {
            setSaving(false);
        }
    }
    
    return (
        <Provider
            value={{
                isSaving,
                saveTicketType,
                ticketType,
                isLoading
            }}
        >
            {children}
        </Provider>
    )
}

export default TicketTypeProvider;